module.exports = __webpack_public_path__ + "img/glasses-solid.f0a3b5db.svg";